export const BREAKPOINT_XL = '1440px';
export const BREAKPOINT_L = '1240px';
export const BREAKPOINT_M = '1050px';
export const BREAKPOINT_S = '600px';
